import {Component, ElementRef, HostListener, Inject, OnInit, ViewChild} from '@angular/core';
import {CodaltComponent} from '../codalt/codalt.component';
import {DIALOG_DATA} from '@angular/cdk/dialog';
import {MatDialogRef} from '@angular/material/dialog';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import {environment} from '../../../environments/environment';
import {LocalStorage} from '../../utils/storage';
import {TtmImage} from '../../classes/ttmimage';
import {TtmStatus} from '../../classes/ttmstatus';
import {getDocument, GlobalWorkerOptions} from 'pdfjs-dist';


@Component({
    selector: 'app-image-viewer',
    templateUrl: './image-viewer.component.html',
    styleUrl: './image-viewer.component.scss'
})
export class ImageViewerComponent extends CodaltComponent implements OnInit {

    zoomlevel = 1;

    images: ImageData[];
    ttmStatuses: TtmStatus[];
    ttmImageDistance = new Map<number, string>();
    @ViewChild('pdfCanvas') pdfCanvas!: ElementRef<HTMLCanvasElement>;
    @ViewChild('swiperRef') swiperComponent?;

    currentPage = 1;
    numberOfPages: number[];
    isAtPhotoLocation = false;
    currentRenderTask: any = null;

    constructor(
        public dialogRef: MatDialogRef<ImageViewerComponent>,
        @Inject(DIALOG_DATA) public data: {
            images: TtmImage[],
            currentImage: TtmImage,
            ttmStatuses: TtmStatus[],
            singleImage?: string,
            singlePdf?: string,
            ttmImageDistance: Map<number, string>
        }) {
        super();
    }

    onScroll(event: WheelEvent) {
        if (event.deltaY < 0) {
            this.zoomlevel = this.zoomlevel + 1;
            this.swiperComponent?.nativeElement.swiper.zoom.in(this.zoomlevel);
        } else {
            if (this.zoomlevel > 1) {
                this.zoomlevel = this.zoomlevel - 1;
                this.swiperComponent?.nativeElement.swiper.zoom.in(this.zoomlevel);
            } else {
                this.swiperComponent?.nativeElement.swiper.zoom.out();
            }
        }
    }

    ngOnInit(): void {
        if (this.data.singlePdf) {
            this.loadPdf(this.data.singlePdf);
        } else if (this.data.singleImage) {
            this.images = [];

        } else {
            this.ttmStatuses = this.data.ttmStatuses;
            this.ttmImageDistance = this.data.ttmImageDistance;
            const index = this.data.images.indexOf(this.data.currentImage);
            const images = this.data.images.map(image => {
                return {
                    image: `${environment.apiEndpoint}api/ttm-images/image/${image.id}?access_token=${LocalStorage.userToken}`,
                    ttmImage: image
                }
            });
            this.images = [...images.slice(index, images.length), ...images.slice(0, index)];
        }
    }

    loadPage(page: number) {
        this.currentPage = page;
        this.loadPdf(this.data.singlePdf, page);
    }

    loadPdf(url: string, page = 1) {
        GlobalWorkerOptions.workerSrc = `assets/pdfjs/pdf.worker.mjs`;

        if (this.currentRenderTask) {
            this.currentRenderTask.cancel();
            this.currentRenderTask = null;
        }

        const loadingTask = getDocument(url);
        loadingTask.promise.then((pdf) => {
            this.numberOfPages = Array.from({length: pdf.numPages}, (_, i) => i+1);
            pdf.getPage(page).then((page) => {
                const scale = 2.5;
                const viewport = page.getViewport({scale});

                const canvas = this.pdfCanvas.nativeElement;
                const context = canvas.getContext('2d')!;
                canvas.height = viewport.height;
                canvas.width = viewport.width;

                const renderContext = {
                    canvasContext: context,
                    viewport: viewport
                };
                this.currentRenderTask = page.render(renderContext);
                this.currentRenderTask.promise.then(() => {
                    this.currentRenderTask = null;
                }).catch((err) => {
                    this.currentRenderTask = null;
                });
            });
        });
    }

    @HostListener('click', ['$event'])
    public click(event) {
        if (event?.target?.localName !== 'img'
            && event?.srcElement?.className.indexOf('wiper-zoom-container') !== -1) {
            this.dialogRef.close();
        }
    }

    onOpenLocation(image: TtmImage) {
        if (image.location) {
            if (this.isAtPhotoLocation) {
                this.dialogRef.close({location: null, ttmId: image.ttm_id});
            } else {
                this.dialogRef.close({location: image.location, ttmId: image.ttm_id});
            }
        }
    }
}

export class ImageData {
    image: string;
    ttmImage: TtmImage;
}
